<template>
  <div class="a-vg-header--main-slider" v-visibility-change="changeVisibility">
    <div class="slides-container">
      <div class="wrapper">
        <transition name="slide">
          <vdog-jackport-info-local-slide
            v-if="isSlideVisible(1)"
            :totalOdds="totalOdds"
            :amount="localJackpot"
            :currency="currency"
          />
        </transition>
      </div>
      <div class="wrapper">
        <transition name="slide">
          <vdog-jackport-info-super-slide
            v-if="isSlideVisible(2)"
            :amount="superJackpot"
            :currency="currency"
          />
        </transition>
      </div>
      <div class="wrapper">
        <transition name="slide">
          <vdog-jackport-info-winning-local-slide
            v-if="isSlideVisible(3)"
            :currency="currency"
            :winningJackpots="WinningJackpotsLocal"
          />
        </transition>
      </div>
      <!-- Last three stadium jackpots -->
      <div class="wrapper">
        <transition name="slide">
          <vdog-jackport-info-winning-super-slide
            v-if="isSlideVisible(4)"
            :currency="currency"
            :winningJackpots="WinningJackpotsSuper"
          />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/grayhound/api.service.js'
import vuexStore from '../../../store/vuexStore'
import NumberFormat from '@/mixins/NumberFormat'
import { eventBus } from '@/main.js'
import LanguageHelper from '@/mixins/LanguageHelper'
import VDogJackpotsInfoLocalSlide from '@/components/grayhound/slides/VDogJackpotsInfoLocalSlide.vue'
import VDogJackpotsInfoSuperSlide from '@/components/grayhound/slides/VDogJackpotsInfoSuperSlide.vue'
import VDogJackpotsInfoWinningLocalSlide from '@/components/grayhound/slides/VDogJackpotsInfoWinningLocalSlide.vue'
import VDogJackpotsInfoWinningSuperSlide from '@/components/grayhound/slides/VDogJackpotsInfoWinningSuperSlide.vue'

import mainTheme from '../../../assets/audio/main_theme.mp3'

export default {
  components: {
    'vdog-jackport-info-local-slide': VDogJackpotsInfoLocalSlide,
    'vdog-jackport-info-super-slide': VDogJackpotsInfoSuperSlide,
    'vdog-jackport-info-winning-local-slide': VDogJackpotsInfoWinningLocalSlide,
    'vdog-jackport-info-winning-super-slide': VDogJackpotsInfoWinningSuperSlide
  },
  mixins: [NumberFormat, LanguageHelper],
  props: {
    currency: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      slideOrder: [],
      Jackpots: [],
      SuperJackpot: [],
      LocalJackpot: [],
      WinningJackpotsSuper: [],
      WinningJackpotsLocal: [],
      showSliderPosition: 0,
      numberOfSlides: 4,
      sliderTimer: null,
      audio: null,
      startSliderTime: 0,
      endSliderTime: 0,
      hasAudioEnabled: vuexStore.state.hasAudioEnabled,
      jackpotsServiceCallInterval: null,
      countdownTimer: 0
    }
  },
  watch: {
    hasAudioEnabled () {
      if (this.hasAudioEnabled) {
        if (this.audio === null) {
          this.audio = new Audio(mainTheme)
          this.audio.addEventListener('ended', function () {
            this.currentTime = 0
            this.play()
          }, false)
          this.audio.play()
        }
      } else {
        if (this.audio !== null) {
          this.audio.pause()
          this.audio = null
        }
      }
    }
  },
  mounted: function () {
    if (this.hasAudioEnabled) {
      if (this.audio === null) {
        this.audio = new Audio(mainTheme)
        this.audio.addEventListener('ended', function () {
          this.currentTime = 0
          this.play()
        }, false)
        this.audio.play()
      }
    } else {
      if (this.audio !== null) {
        this.audio.pause()
        this.audio = null
      }
    }
    this.$watch(
      () => vuexStore.state.hasAudioEnabled,
      () => {
        this.hasAudioEnabled = vuexStore.state.hasAudioEnabled
      }
    )
    this.jackpotsServiceCallInterval = setInterval(() => {
      if (this.countdownTimer >= 5) {
        this.computeJackpots()
      }
    }, vuexStore.state.randomGeneratedJackpotInterval * 1000)
  },
  created: function () {
    eventBus.$on('vdog_timer_tick', (data) => {
      this.countdownTimer = data
    })
    this.computeJackpots()
  },
  computed: {
    totalOdds: function () {
      let result
      if (this.Jackpots) {
        let jackpotValue = this.Jackpots.filter(jackpot => jackpot.Type === 'Local JP')
        if (jackpotValue && jackpotValue.length > 0) {
          result = this.formatNumber((jackpotValue[0].JackpotPrerequisite / 100), this.getLanguageCodeForNumbers())
        }
      }
      if (!result) {
        if (this.LocalJackpot && this.LocalJackpot.length > 0) {
          result = this.formatNumber((this.LocalJackpot[0].JackpotPrerequisite / 100), this.getLanguageCodeForNumbers())
        }
      }
      return result + ''
    },
    localJackpot: function () {
      if (this.LocalJackpot && this.LocalJackpot.length > 0) {
        return this.LocalJackpot[0].Amount === 0 ? 0 : this.LocalJackpot[0].Amount
      }
      return 0
    },
    superJackpot: function () {
      if (this.SuperJackpot && this.SuperJackpot.length > 0) {
        return this.SuperJackpot[0].Amount === 0 ? 0 : this.SuperJackpot[0].Amount
      }
      return 0
    }
  },
  methods: {
    computeJackpots: function () {
      api.getJackpot().subscribe(data => {
        this.Jackpots = data.jackpots
        if (data.localJackpot.length > 0) {
          this.LocalJackpot = data.localJackpot
          this.slideOrder.push(1)
        }
        if (data.superJackpot.length > 0) {
          this.SuperJackpot = data.superJackpot
          this.slideOrder.push(2)
        }
        if (data.winningJackpotsLocal.length > 0) {
          this.WinningJackpotsLocal = data.winningJackpotsLocal
          this.slideOrder.push(3)
        }
        if (data.winningJackpotsSuper.length > 0) {
          this.WinningJackpotsSuper = data.winningJackpotsSuper
          this.slideOrder.push(4)
        }
        this.showSlides(true)
      }, eventBus.onApiError)
    },
    changeVisibility: function (visibility, hidden) {
      if (hidden) {
        clearInterval(this.sliderTimer)
      } else {
        this.previousSlide()
        this.showSlides()
      }
    },
    isSlideVisible: function (slide) {
      return this.slideOrder[this.showSliderPosition] === slide
    },
    nextSlide () {
      this.showSliderPosition = ((this.showSliderPosition + 1) % this.slideOrder.length)
    },
    previousSlide () {
      this.showSliderPosition = ((this.showSliderPosition - 1) % this.slideOrder.length)
    },
    showSlides (ignoreNextSlide) {
      if (!ignoreNextSlide) {
        this.nextSlide()
      }
      if (this.sliderTimer) {
        clearInterval(this.sliderTimer)
      }
      this.sliderTimer = setInterval(() => {
        this.nextSlide()
      }, 10 * 1000)
    }
  },
  beforeDestroy () {
    clearInterval(this.sliderTimer)
    if (this.jackpotsServiceCallInterval !== null) {
      clearInterval(this.jackpotsServiceCallInterval)
    }
  },
  destroyed () {
    if (this.audio !== null) {
      this.audio.pause()
      this.audio = null
    }
  }
}
</script>
